<template>
    <div class="home">
        <Topbar />
        <div class="container-fluid text-left" style="margin-top: 90px">
            <!-- Content Row -->
            <div class="card shadow mb-4">
                <div class="card-header bg-secondary py-3">
                    <h6 class="m-0 font-weight-bold text-white">
                        <i :class="`${title.icon} mr-2`"></i>{{ title.text }}
                        <div v-show="carregando" class="spinner-grow">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </h6>
                </div>
                <fieldset :disabled="carregando">
                    <div class="card-body bg-light text-primary-dark">
                        <p>
                            <a
                                class="btn btn-link"
                                data-toggle="collapse"
                                href="#filtrocard"
                                aria-expanded="false"
                                aria-controls="collapseExample"
                            >
                                <i class="fas fa-filter"></i>
                                Filtro
                            </a>

                            <router-link class="btn btn-link" :to="`/${baseUrl}/insert`"
                                ><i class="fa fa-fw fa-plus"></i> Adicionar
                            </router-link>
                        </p>
                        <div class="collapse" id="filtrocard">
                            <div class="card card-body bg-light">
                                <div class="form-row align-items-center">                                    
                                    <InputAndLabel
                                        column="3"
                                        name="pesquisa"
                                        label="Pesquisa"
                                        type="text"
                                        v-model="filtro.pesquisa"
                                    />

                                    <div class="form-group col-md-auto pt-md-2">
                                        <button
                                            type="submit"
                                            class="btn btn-primary form-control mt-md-4"
                                            id="pesquisar"
                                            @click="list"
                                        >
                                            Pesquisar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="collapse" id="filtrocardImportacao">
                            <div class="card card-body bg-light">
                                <div class="row">
                                    <div class="custom-file form-group col-md-5 ml-2 mt-2">
                                        <input type="hidden" name="arquivo" id="arquivo" v-model="arquivoNome" />
                                        <input
                                            type="file"
                                            class="custom-file-input"
                                            name="files[]"
                                            @change="handleEscolhaArquivo"
                                            id="userfile"
                                            multiple
                                        />
                                        <label
                                            class="custom-file-label"
                                            for="userfile"
                                            data-browse="Buscar"
                                            id="etiqueta"
                                        >
                                            {{ arquivoLabel }}</label
                                        >
                                    </div>
                                    <button
                                        type="submit"
                                        id="btn_save"
                                        name="btn_save"
                                        value="UPLOAD"
                                        class="btn btn-success ml-2 mt-2"
                                        @click="importarPlanilha"
                                        :disabled="arquivos == null"
                                    >
                                        Importar
                                    </button>
                                </div>
                            </div>
                        </div>

                        <hr />
                        <div class="row">
                            <div class="col-lg-12 table-responsive">
                                <table class="table table-sm table-striped table-bordered">
                                    <thead>
                                        <tr style="white-space: nowrap">
                                            <th></th>                                            
                                            <TableHeader db="razaosocial" label="Razão Social" />
                                            <TableHeader db="fantasia" label="Fantasia" />
                                            <TableHeader db="cnpj" label="CNPJ" />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="line in dados" :key="line[idname]" :style="{backgroundColor: '#'+line.statusbackground, color: '#'+line.statuscolor,}">
                                            <td>
                                                <router-link
                                                    :to="`/${baseUrl}/${line[idname]}`"
                                                    data-toggle="tooltip"
                                                    title="Editar/Visualizar"
                                                    ><i class="fa fa-edit"></i
                                                ></router-link>
                                            </td>
                                            <td>{{ line.razaosocial }}</td>
                                            <td>{{ line.fantasia }}</td>
                                            <td>{{ maskCNPJCPF(line.cnpj) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <TableFooter />
                    </div>
                </fieldset>
            </div>
        </div>
        <ForbiddenModal />
        <LogoutModal />
        <Sidebar/>
    </div>
</template>

<script>
// @ is an alias to /src
import Topbar from "@/components/Topbar.vue";
import Sidebar from '@/components/Sidebar.vue';
import LogoutModal from "@/components/LogoutModal.vue";
import TableHeader from "@/components/TableHeader.vue";
import ViewMixin from "./ViewMixin";
import api from "../services/api";
import $ from "jquery";
import {
    ClientErrorException,
    DEFAULT_ERROR_MESSAGE,
    PermissaoException,
    ServerErrorException,
    TokenInvalidoException,
} from "../services/exceptions";
import { enterKey } from "../utils";
import ForbiddenModal from "../components/ForbiddenModal.vue";
import TableFooter from "../components/TableFooter.vue";
import InputAndLabel from "../components/InputAndLabel.vue";

export default {
    name: "Usuarios",
    mixins: [ViewMixin],
    components: {
        Topbar,
        Sidebar,
        LogoutModal,
        TableHeader,
        ForbiddenModal,
        TableFooter,
        InputAndLabel
    },
    data: () => {
        return {
            idname: "idcliente",
            baseUrl: "clientes",
            title: {
                icon: "fas fa-address-book",
                text: "Clientes",
            },
            sort: "razaosocial",
            sortDirection: "asc",
            filtro: {
                pesquisa: "",
            },
            arquivoLabel: "Selecionar Arquivo",
            arquivoNome: "",
            arquivos: null,
        };
    },
    mounted() {
        this.getCombos();
        this.list();
    },
    methods: {
        enterKey,

        handleEscolhaArquivo(e) {
            if (e.target.files.length > 0) {
                this.arquivoLabel = "";
                for (const element of e.target.files) {
                    const file = element;
                    this.arquivoLabel += '"' + file.name + '" ';
                }
                this.arquivoNome = e.target.files[0].name;
                this.arquivos = e.target.files;
            } else {
                this.arquivoLabel = "Selecionar Arquivo";
                this.arquivos = null
            }
        },

        async getCombos() {
            this.carregando = true;

            try {
                $("#filtrocard").collapse("hide");

                let { baseUrl } = this;
                let response = await api.get(`/${baseUrl}/combos`);

                this.combos = response.data;
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }

            this.carregando = false;
        },

        async list() {
            this.carregando = true;

            try {
                $("#filtrocard").collapse("hide");

                let { baseUrl, sort, sortDirection, filtro, perPage, pular } = this;
                let response = await api.get(`/${baseUrl}`, {
                    params: {
                        sort: `${sort} ${sortDirection}`,
                        ...filtro,
                        perPage,
                        pular
                    },
                });

                this.dados = response.data.dados;
                this.totalRows = response.data.totalRows;
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                }
            }

            this.carregando = false;
        },

        async importarPlanilha() {
            this.carregando = true;

            try {
                $("#filtrocardImportacao").collapse("hide");

                let { baseUrl, arquivos } = this;
                const formData = new FormData();
                for (let i = 0; i < arquivos.length; i++) {
                    formData.append(`files[${i}]`, arquivos[i]);
                }

                await api.post(
                    `/${baseUrl}/importar`,
                    formData,
                    { headers: { "content-type": "multipart/form-data" } }
                );

                this.dados = [];
                this.list();
            } catch (e) {
                if (e instanceof TokenInvalidoException) {
                    this.handleTokenInvalidoException();
                } else if (e instanceof PermissaoException) {
                    this.handlePermissaoException();
                } else if (e instanceof ClientErrorException || e instanceof ServerErrorException) {
                    alert(e.message);
                } else {
                    alert(DEFAULT_ERROR_MESSAGE);
                    console.error(e);
                }
            }

            this.carregando = false;
        },
    },
};
</script>

<style scoped lang="scss">
.spinner-grow {
    width: 1em;
    height: 1em;
}

@media only screen and (min-width: 768px) {
    /* css */
}
</style>
